"use client";

import dynamic from "next/dynamic";

const PageAnimations = dynamic(() => import("./PageAnimations"), {
  ssr: false,
  loading: () => null,
});

export default function PageAnimationsWrapper() {
  return <PageAnimations />;
}
